import cx from 'classnames';
import { SearchWithMetadata } from '@retro-ui/api-contract';

import cls from './SearchInfo.module.css';

interface SearchInfoProps {
  search: SearchWithMetadata;
}
export default function SearchInfo(props: SearchInfoProps) {
  const { search } = props;

  const { isRemoved, status, size } = search;

  const statusList = status
    ? Object.entries({
        completed: status.finished,
        running: status.running,
        failed: status.error,
        queued: status.queued,
      }).filter(([, value]) => value !== 0)
    : [];

  if (isRemoved) {
    return null;
  }
  return (
    <>
      <div className={cls.statusBar}>
        {statusList.map(([status, value]) => (
          <div
            key={status}
            className={cx(cls.statusBarElement, cls[`${status}Bar`])}
            style={{ width: `${100 * (value / size)}%` }}
          />
        ))}
      </div>
      <div className={cls.statusLabels}>
        {statusList.map(([status, value]) => (
          <div key={status} className={cls.value}>
            <span className={cls[status]}>{value}</span> <small className={cls.label}>{status}</small>
          </div>
        ))}
      </div>
    </>
  );
}
